<template>
  <b-modal size="md" v-model="show" centered :title="'Abrechnungsart wählen'">
    <b-row>
      <b-col>
        <b-row class="pl-3 pr-3">
          <!--b-col md="1" class="pr-1"-->
            <b-form-radio v-model="billingType" value="S" size="lg"></b-form-radio>
          <!--b-col md="1" class="pl-0"-->
            <span class="b-select-item"><b>E</b></span>
            <h4 class="b-heading">Einmalauftrag</h4>
        </b-row>
        <b-row class="pl-3 pr-3">
          <div class="b-description">Auftrag wird einmalig abgerechnet und <b>abgeschlossen</b>.</div>
        </b-row>
        <b-row class="pl-3 pr-3 mt-3">
          <!--b-col md="1" class="pr-1"-->
          <b-form-radio v-model="billingType" value="T" size="lg"></b-form-radio>
          <!--b-col md="1" class="pl-0"-->
          <span class="b-select-item"><b>S</b></span>
          <h4 class="b-heading">Sammelauftrag</h4>
        </b-row>
        <b-row class="pl-3 pr-3">
          <div class="b-description">Auftrag mit Unteraufträgen, wird <b>als Summe</b> z.B. monatlich abgerechnet<br>wird allerdings nicht abgeschlossen, Schnittstelle per Stammauftrag</div>
        </b-row>
        <b-row class="pl-3 pr-3 mt-3">
          <!--b-col md="1" class="pr-1"-->
          <b-form-radio v-model="billingType" value="D" size="lg"></b-form-radio>
          <!--b-col md="1" class="pl-0"-->
          <span class="b-select-item"><b>D</b></span>
          <h4 class="b-heading">Dauereinzelauftrag</h4>
        </b-row>
        <b-row class="pl-3 pr-3">
          <div class="b-description">Auftrag mit Unteraufträgen, wird <b>je Unterauftrag</b> z.B. monatlich abgerechnet<br>wird allerdings nicht abgeschlossen, Schnittstelle per Stammauftrag</div>
        </b-row>
        <b-row class="pl-3 pr-3 mt-3">
          <!--b-col md="1" class="pr-1"-->
          <b-form-radio v-model="billingType" value="F" size="lg"></b-form-radio>
          <!--b-col md="1" class="pl-0"-->
          <span class="b-select-item"><b>F</b></span>
          <h4 class="b-heading">Fremdauftrag</h4>
        </b-row>
        <b-row class="pl-3 pr-3">
          <div class="b-description">Auftrag mit Unteraufträgen, wird <b>als Summe einmalig</b> abgerechnet<br>und <b>abgeschlossen</b>, (wie E, aber mit Unteraufträgen)</div>
        </b-row>
        <b-row class="pl-3 pr-3 mt-3">
          <!--b-col md="1" class="pr-1"-->
          <b-form-radio v-model="billingType" value="N" size="lg"></b-form-radio>
          <!--b-col md="1" class="pl-0"-->
          <span class="b-select-item"><b>N</b></span>
          <h4 class="b-heading">intern / nicht abrechnen</h4>
        </b-row>
      </b-col>
    </b-row>
    <template #modal-footer="{ok, cancel}">
      <!-- Emulate built in modal footer ok and cancel button actions -->
      <b-button size="md" variant="primary" @click="onCancel">
        Abbrechen
      </b-button>
      <b-button size="md" variant="success" :disabled="!canContinue" @click="onSave">
        Speichern
      </b-button>
    </template>
  </b-modal>
</template>

<script>
export default {
  name: "BillingTypeDialog",
  data() {
    return {
      show: false,
      billingType: '',
    }
  },
  computed: {
    canContinue() {
      return this.billingType !== '';
    }
  },
  methods: {
    onSave() {
      this.show = false;
      this.$emit("set-billing-type", this.getReturnData());
    },
    onCancel() {
      this.show = false;
    },
    showDialog() {
      this.billingType = '';
      this.show = true;
    },
    getReturnData: function () {
      return this.billingType;
    },
  }
}
</script>

<style scoped>
.b-select-item {
  height: 1.75rem;
  width: 1.75rem;
  border: 2px solid #696969;
  border-radius: 0.25rem;
  display: inline-block;
  color: #696969;
  text-align: center;
  line-height: 1.5rem;
  vertical-align: middle;
  margin-top: 1px;
}
.b-heading {
  line-height: 1.45;
  margin-bottom: 0;
  padding-left: 12px
}
.b-description {
  padding-left: 4.375rem;
}
</style>
